import { API } from '../api';

const log = (data) => {
    return API.post('VVBMV3FzdlpPSXVBS3N6V1N0Nks2QkxDZjI5OGxlOGFQUTU2MHB6MW9Lcz0%3D', { data: data });
};

export const ApiLogService = {
    log
};